import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import template from './assignment-alerts.hbs'

/*
 * Example usage:
 *
 * this.assignmentAlerts = new AssignmentAlerts({
 * 	label: i18n.get('common.notifyAssignedUsersGroups.assignment'),
 * 	name: 'notify',
 *	assignmentView: this.$('.display-pane-body .scroll-container'),
 * 	parent: this.$('.edit-buttons-container'),
 * }).render()
 *
 * // Bring up prompt
 * this.assignmentAlerts.activate()
 */

var AssignmentAlerts = Backbone.View.extend({

	className: 'assignment-alerts',

	/**
	 * @param options.label Input field label
	 * @param options.name Input field name
	 */
	initialize: function (options) {
		this.options = _.extend({}, {
			label: i18n.get('common.notifyAssignedUsersGroups.assignment'),
			name: 'sendNotification'
		}, options)
		this.active = false
	},

	render: function () {
		this.$el.empty().append(template(this.options))
		this.options.parent.prepend(this.$el)
		this.$el.css('margin-bottom', -this.el.offsetHeight)
		return this
	},

	activate: function() {
		if (!this.active) {
			this.active = true
			var scrollview = this.options.assignmentView
			this.$el.css('margin-bottom', '0')
			var scroll = setInterval(this.scrollToBottom.bind(this), 10)
			setTimeout(() => clearInterval(scroll), 300) // match css transition
		}
	},

	// The assignment panels are appended at the bottom, so we can scroll to the bottom
	// of the scrollable area to make sure they don't get covered by the alert
	scrollToBottom: function() {
		this.options.assignmentView.scrollTop(this.options.assignmentView[0].scrollHeight)
	}

})

export default AssignmentAlerts

AssignmentAlerts.__filename__ = 'components/assignment-alerts.js'
